export const MODULES = {
  APP: 'app',
  ENTERPRISE: 'enterprise',
  SYNDIC: 'syndic',
  FINANCIAL: 'financial',
  PAYMENT_SLIPS: 'payment_slips',
  DOCUMENT: 'document',
  BULLETIN: 'bulletin',
  NEWS: 'news',
  SUPPORT: 'support',
  PROFILE: 'profile',
  AUTH: 'auth',
  UNIT: 'unit',
  TICKET_CRM: 'ticket_crm',
};

export const APP = {
  ISLOADING: 'app/ISLOADING',
  LOADING: 'app/LOADING',
  LOADED: 'app/LOADED',
  LOGOUT: 'user/LOGOUT',
  IS_CONFIG_LOADING: 'app/IS_CONFIG_LOADING',
  LOADING_CONFIG: 'app/LOADING_CONFIG',
  LOADED_CONFIG: 'app/LOADED_CONFIG',
  IS_ADMIN_PREVIEW: 'app/IS_ADMIN_PREVIEW',
  GET_ADMIN_PREVIEW: 'app/GET_ADMIN_PREVIEW',
  MUTATE_ADMIN_PREVIEW: 'app/MUTATE_ADMIN_PREVIEW',
  OPEN_SNACKBAR: 'snackbar:open',
  NAVBAR_ROUTES: 'app/NAVBAR_ROUTES',
  APP_MODULES: 'app/APP_MODULES',
  PAGES: 'app/PAGES',
  BLOCKADE_WARNING: 'app/BLOCKADE_WARNING',
};
export const CONFIG = {
  GET: 'config/GET',
  GET_TENANT_ID: 'config/GET_TENANT_ID',
  GET_INSTITUTIONAL_SITE_URL: 'config/GET_INSTITUTIONAL_SITE_URL',
  GET_SHARED: 'config/GET_SHARED',
  GET_NAVIGATION_RULES: 'config/GET_NAVIGATION_RULES',
  GET_EMAIL_ENABLED: 'config/GET_EMAIL_ENABLED',
  GET_SMS_ENABLED: 'config/GET_SMS_ENABLED',
  GET_SHARED_INTEGRATIONS: 'config/GET_SHARED_INTEGRATIONS',
  GET_JUNIX_BANK_FINANCING_BASE_URL: 'config/GET_JUNIX_BANK_FINANCING_BASE_URL',
  GET_JUNIX_STATUS_URL: 'config/GET_JUNIX_STATUS_URL',
  GET_KITFIX_URL: 'config/GET_KITFIX_URL',
  GET_POPUPS: 'config/GET_POPUPS',
  GET_SLIP_TIMEOUT_HOURS: 'config/GET_SLIP_TIMEOUT_HOURS',
  GET_SLIP_SOLICITATION_DAYS: 'config/GET_SLIP_SOLICITATION_DAYS',
  GET_TO_EXPIRE_PERIOD_DAYS: 'config/GET_TO_EXPIRE_PERIOD_DAYS',
  SET: 'config/SET',
  GET_DB_CONFIG: 'config/GET_DB_CONFIG',
  SET_DB_CONFIG: 'config/SET_DB_CONFIG',
  GET_FINANCIAL_RULE: 'config/GET_FINANCIAL_RULE',
  GET_IFRAME: 'config/GET_IFRAME',
  GET_COMPLIANCE: 'config/GET_COMPLIANCE',
  GET_IS_COMPLIANCE_ACTIVE: 'config/GET_IS_COMPLIANCE_ACTIVE',
  GET_IS_COMPLIANCE_ACTIVE_ADMIN: 'config/GET_IS_COMPLIANCE_ACTIVE_ADMIN',
  GET_LOGTRACE_WAIT_MS: 'config/GET_LOGTRACE_WAIT_MS',
  SHOW_BLOCKADE_WARNING: 'config/SHOW_BLOCKADE_WARNING',
};
export const TICKET_CRM = {
  GET_ENABLED: 'ticketCrm/GET_ENABLED',
  GET_TOKEN: 'ticketCrm/GET_TOKEN',
  SET_TOKEN: 'ticketCrm/SET_TOKEN',
  FETCH_TOKEN: 'ticketCrm/FETCH_TOKEN',
  GET_TICKETS: 'ticketCrm/GET_TICKETS',
  SET_TICKETS: 'ticketCrm/SET_TICKETS',
  FETCH_TICKET: 'ticketCrm/FETCH_TICKET',
  FETCH_PROPOSERS_TICKETS: 'ticketCrm/FETCH_PROPOSERS_TICKETS',
  HAS_NEW_TICKET: 'ticketCrm/HAS_NEW_TICKET',
  NEW_TICKET_CREATED: 'ticketCrm/NEW_TICKET_CREATED',
  NEW_TICKET_LISTED: 'ticketCrm/NEW_TICKET_LISTED',
  DEFAULT_SUPPORT_ITEMS: {
    inAnalysis: [],
    directed: [],
    waitingReply: [],
    inProgress: [],
    done: [],
    lastTicket: null,
  },
};

export const BANNER = {
  GET_BANNERS: 'banners/GET_BANNERS',
  GET_BANNER_LOADING: 'banners/GET_BANNER_LOADING',
  SET_BANNERS: 'banners/SET_BANNERS',
  FETCH_BANNERS: 'banners/FETCH_BANNERS',
};

export const FAQ = {
  GET_FAQS: 'faqs/GET_FAQS',
  GET_FAQS_LOADING: 'faqs/GET_FAQS_LOADING',
  GET_FAQS_ERROR: 'faqs/GET_FAQS_ERROR',
  SET_FAQS: 'faqs/SET_FAQS',
  FETCH_FAQS: 'faqs/FETCH_FAQS',
};

export const USER = {
  GET_FULL: 'user/GET_FULL',
  GET_USER: 'user/GET_USER',
  GET_USER_ROLE: 'user/GET_USER_ROLE',
  GET_IMOBME_DATA: 'user/GET_IMOBME_DATA',
  GET_CELLPHONE_STRING: 'user/GET_CELLPHONE_STRING',
  GET_USER_POPUPS: 'user/GET_USER_POPUPS',
  HAS_COMPLIANCE: 'user/HAS_COMPLIANCE',
  MUTATE_USER: 'user/MUTATE_USER',
  MUTATE_IMOBME_DATA: 'user/MUTATE_IMOBME_DATA',
};
export const UNIT = {
  GET_ALL: 'unit/GET_ALL',
  GET_SELECTED: 'unit/GET_SELECTED',
  GET_SELECTED_PRODUCT: 'unit/GET_SELECTED_PRODUCT',
  GET_SELECTED_PRODUCT_DETAILS: 'unit/GET_SELECTED_PRODUCT_DETAILS',
  GET_DISCOUNT_LIST: 'unit/GET_DISCOUNT_LIST',
  GET_CONCLUSION_CERTIFICATE_DATE: 'unit/GET_CONCLUSION_CERTIFICATE_DATE',
  GET_SEGMENTATIONS: 'unit/GET_SEGMENTATIONS',
  GET_IS_SETTLED: 'unit/GET_IS_SETTLED',
  GET_IS_INDIRECT: 'unit/GET_IS_INDIRECT',
  GET_IS_SYNDIC: 'unit/GET_IS_SYNDIC',
  GET_IS_KEY_DELIVERED: 'unit/GET_IS_KEY_DELIVERED',
  GET_DEBIT_BLOCK: 'unit/GET_DEBIT_BLOCK',
  GET_SHOW_IN_CONSTRUCTION: 'unit/GET_SHOW_IN_CONSTRUCTION',
  GET_SHOW_DECORATED: 'unit/GET_SHOW_DECORATED',
  UNIT_SEGMENTATIONS_MUTATE: 'unit/UNIT_SEGMENTATIONS_MUTATE',
  MUTATE: 'unit/MUTATE',
  SET: 'unit/SET',
  SELECT: 'unit/SELECT',
  PRODUCT_MUTATE: 'unit/PRODUCT_MUTATE',
  FETCH_PRODUCT: 'unit/FETCH_PRODUCT',
  PRODUCT_DETAILS_MUTATE: 'unit/PRODUCT_DETAILS_MUTATE',
  FETCH_PRODUCT_DETAILS: 'unit/FETCH_PRODUCT_DETAILS',
  SYNDIC_MAINTENANCE_LINK: 'unit/SYNDIC_MAINTENANCE_LINK',
  SYNDIC_MANUAL_LINK: 'unit/SYNDIC_MANUAL_LINK',
  SYNDIC_PRODUCTS: 'unit/SYNDIC_PRODUCTS',
};
export const BULLETINS = {
  HAS_BULLETINS: 'bulletins/HAS_BULLETINS',
  GET_BULLETINS: 'bulletins/GET_BULLETINS',
  SET_BULLETINS: 'bulletins/SET_BULLETINS',
  FETCH_BULLETINS: 'bulletins/FETCH_BULLETINS',
  CHANGE_PAGE: 'bulletins/CHANGE_PAGE',
  GET_PDF_PAGES: 'bulletins/GET_PDF_PAGES',
  IS_LOADING: 'bulletins/IS_LOADING',
  HAS_ERROR: 'bulletins/HAS_ERROR',
};

export const DOCS = {
  HAS_LEGAL_DOCS: 'docs/HAS_LEGAL_DOCS',
  HAS_GENERAL_DOCS: 'docs/HAS_GENERAL_DOCS',
  GET_LEGAL_DOCS: 'docs/GET_LEGAL_DOCS',
  GET_GENERAL_DOCS: 'docs/GET_GENERAL_DOCS',
  SET_LEGAL_DOCS: 'docs/SET_LEGAL_DOCS',
  SET_GENERAL_DOCS: 'docs/SET_GENERAL_DOCS',
  IS_LOADING: 'docs/IS_LOADING',
  HAS_ERROR: 'docs/HAS_ERROR',
  HAS_OWNER_DOCS: 'docs/HAS_OWNER_DOCS',
  GET_OWNER_DOCS: 'docs/GET_OWNER_DOCS',
  SET_OWNER_DOCS: 'docs/SET_OWNER_DOCS',
  GET_SYNDIC_DOCS: 'docs/GET_SYNDIC_DOCS',
  SET_SYNDIC_DOCS: 'docs/SET_SYNDIC_DOCS',
  HAS_SYNDIC_DOCS: 'docs/HAS_SYNDIC_DOCS',
};

export const IFRAME = {
  GET_INTERACTION: 'iFrame/GET_INTERACTION',
  GET_MY_ENTERPRISE_PAGE_URL: 'iFrame/GET_MY_ENTERPRISE_PAGE_URL',
  GET_MY_ENTERPRISE_CARD_URL: 'iFrame/GET_MY_ENTERPRISE_CARD_URL',
  GET_CONSTRUCTION_PAGE_URL: 'iFrame/GET_CONSTRUCTION_PAGE_URL',
  GET_CONSTRUCTION_CARD_URL: 'iFrame/GET_CONSTRUCTION_CARD_URL',
  GET_DECORATED_PAGE_URL: 'iFrame/GET_DECORATED_PAGE_URL',
  GET_DECORATED_CARD_URL: 'iFrame/GET_DECORATED_CARD_URL',
  GET_LOGO_MASK: 'iFrame/GET_LOGO_MASK',
  GET_NEWS_TYPES: 'iFrame/GET_NEWS_TYPES',
  GET_CONSTRUCTION: 'iFrame/GET_CONSTRUCTION',
  SET_INTERACTION: 'iFrame/SET_INTERACTION',
  GET_DATA: 'iFrame/GET_DATA',
};

export const LOGTRACE = {
  GET: 'logTrace/GET',
  ADD: 'logTrace/ADD',
  CLEAR: 'logTrace/CLEAR',
};

export const ROLES = {
  ADMIN_ROLE: 'admin',
  CLIENT_ROLE: 'client',
  SYNDIC_ROLE: 'syndic',
};

export const PROFILES = {
  ADMIN_BEXS_PROFILE: 'bexs',
  ADMIN_PROFILE: 'admin',
  ADMIN_HR_PROFILE: 'humanResourcesAdmin',
  HR_PROFILE: 'humanResources',
  FINANCIAL_PROFILE: 'financial',
  ADMIN_FINANCIAL_PROFILE: 'financialAdmin',
};

export const NOTIFICATIONS = {
  GET_ALL: 'notifications/GET_ALL',
  GET_VISUALIZED: 'notifications/GET_VISUALIZED',
  MUTATE_GENERAL_DOCUMENTS: 'notifications/MUTATE_GENERAL_DOCUMENTS',
  MUTATE_LEGAL_DOCUMENTS: 'notifications/MUTATE_LEGAL_DOCUMENTS',
  MUTATE_OWNER_DOCUMENTS: 'notifications/MUTATE_OWNER_DOCUMENTS',
  MUTATE_BULLETINS: 'notifications/MUTATE_BULLETINS',
  MUTATE_TO_EXPIRE_PAYMENT_SLIPS:
    'notifications/MUTATE_TO_EXPIRE_PAYMENT_SLIPS',
  MUTATE_LATE_PAYMENT_SLIPS: 'notifications/MUTATE_LATE_PAYMENT_SLIPS',
  MUTATE_ANTICIPATION_PAYMENT_SLIPS:
    'notifications/MUTATE_ANTICIPATION_PAYMENT_SLIPS',
  MUTATE_VISUALIZED: 'notifications/MUTATE_VISUALIZED',
  MUTATE_ID: 'notifications/MUTATE_ID',
  MUTATE_EVENT: 'notifications/MUTATE_EVENT',
  LOAD_VISUALIZED: 'notifications/LOAD_VISUALIZED',
  SAVE_VISUALIZED: 'notifications/SAVE_VISUALIZED',
  LOADING: 'notifications/LOADING',
};

export const PAYMENT_SLIPS = {
  HAS_TO_EXPIRE_SLIPS: 'paymentSlips/HAS_TO_EXPIRE_SLIPS',
  GET_TO_EXPIRE: 'paymentSlips/GET_TO_EXPIRE',
  HAS_LATE_SLIPS: 'paymentSlips/HAS_LATE_SLIPS',
  HAS_PAYABLE_LATE_SLIPS: 'paymentSlips/HAS_PAYABLE_LATE_SLIPS',
  HAS_FUTURE_SLIPS: 'paymentSlips/HAS_FUTURE_SLIPS',
  GET_TO_EXPIRE_BY_CONTRACT: 'paymentSlips/GET_TO_EXPIRE_BY_CONTRACT',
  GET_IS_LOADING: 'paymentSlips/GET_IS_LOADING',
  HAS_SLIP_ERROR: 'paymentSlips/HAS_SLIP_ERROR',
  GET_TO_EXPIRE_ALLOWED_CONTRACTS:
    'paymentSlips/GET_TO_EXPIRE_ALLOWED_CONTRACTS',
  MUTATE_LOADING: 'paymentSlips/MUTATE_LOADING',
  MUTATE_ERROR: 'paymentSlips/MUTATE_ERROR',
  MUTATE_TO_EXPIRE_PAYMENT_SLIPS: 'paymentSlips/MUTATE_TO_EXPIRE_PAYMENT_SLIPS',
  MUTATE_TO_EXPIRE_SLIP: 'paymentSlips/MUTATE_TO_EXPIRE_SLIP',
  FETCH_TO_EXPIRE: 'paymentSlips/FETCH_TO_EXPIRE',
  FETCH_CORRECT_VALUE: 'paymentSlips/FETCH_CORRECT_VALUE',
};

export const SOLICITATE_TYPE = {
  LATE: 'Late',
  ANTICIPATION: 'Anticipation',
};

export const NEWS_VIDEOS = {
  GET_VIDEOS: 'newsVideo/GET_NEWS_VIDEOS',
  SET_VIDEOS: 'newsVideo/SET_NEWS_VIDEOS',
  FETCH_VIDEOS: 'newsVideo/FETCH_NEWS_VIDEOS',
  HAS_VIDEOS: 'newsVideo/HAS_NEWS_VIDEOS',
};

export const EVENTS = {
  GET_AGI: 'events/GET_AGI',
  SET_AGI: 'events/SET_AGI',
  UPDATE_AGI: 'events/UPDATE_AGI',
  GET_GENERIC: 'events/GET_GENERIC',
  SET_GENERIC: 'events/SET_GENERIC',
  UPDATE_GENERIC: 'events/UPDATE_GENERIC',
  GET_ALLOCATIONEQUITYVISIT: 'events/GET_ALLOCATIONEQUITYVISIT',
  SET_ALLOCATIONEQUITYVISIT: 'events/SET_ALLOCATIONEQUITYVISIT',
  UPDATE_ALLOCATIONEQUITYVISIT: 'events/UPDATE_ALLOCATIONEQUITYVISIT',
  GET_ALLOCATIONEQUITYASSEMBLY: 'events/GET_ALLOCATIONEQUITYASSEMBLY',
  SET_ALLOCATIONEQUITYASSEMBLY: 'events/SET_ALLOCATIONEQUITYASSEMBLY',
  UPDATE_ALLOCATIONEQUITYASSEMBLY: 'events/UPDATE_ALLOCATIONEQUITYASSEMBLY',
  GET_KEYDELIVERY: 'events/GET_KEYDELIVERY',
  SET_KEYDELIVERY: 'events/SET_KEYDELIVERY',
  UPDATE_KEYDELIVERY: 'events/UPDATE_KEYDELIVERY',
  GET_INSPECTION: 'events/GET_INSPECTION',
  SET_INSPECTION: 'events/SET_INSPECTION',
  UPDATE_INSPECTION: 'events/UPDATE_INSPECTION',
  GET_TECHNICAL_ASSISTANCE: 'events/GET_TECHNICAL_ASSISTANCE',
  SET_TECHNICAL_ASSISTANCE: 'events/SET_TECHNICAL_ASSISTANCE',
  FETCH_TECHNICAL_ASSISTANCE: 'events/FETCH_TECHNICAL_ASSISTANCE',
  FETCH_EVENTS: 'events/FETCH_EVENTS',
  GET_SCHEDULE: 'events/GET_SCHEDULE',
  SET_SCHEDULE: 'events/SET_SCHEDULE',
  FETCH_SCHEDULE: 'events/FETCH_SCHEDULE',
  GET_APPOINTMENT: 'events/GET_APPOINTMENT',
  RESET_TECHNICAL_ASSISTANCE_CACHE: 'events/RESET_TECHNICAL_ASSISTANCE_CACHE',
};

export const CONSTRUCTION_STAGE = {
  LAUNCH: 'launch',
  IN_CONSTRUCTION: 'inConstruction',
  DELIVERED: 'delivered',
};

export const SEGMENTATIONS = {
  ASSOCIATIVE__REHEARSE_STATUS: 'associative_rehearseStatus',
  ASSOCIATIVE_REHEARSED__REHEARSE_STATUS: 'associativeRehearsed_rehearseStatus',
  SFH__REHEARSE_STATUS: 'sfh_rehearseStatus',
  SETTLED__REHEARSE_STATUS: 'settled_rehearseStatus',
  DIRECT__REHEARSE_STATUS: 'direct_rehearseStatus',
  LAUNCH__CONSTRUCTION_STAGE: 'launch_constructionStage',
  IN_CONSTRUCTION__CONSTRUCTION_STAGE: 'inConstruction_constructionStage',
  DELIVERED__CONSTRUCTION_STAGE: 'delivered_constructionStage',
  KEYS_DELIVERED__CONSTRUCTION_STAGE: 'keysDelivered_constructionStage',
  UNDEFINED__CONSTRUCTION_STAGE: 'undefined_constructionStage',
  SYNDIC__USER_ROLE: 'syndic_userRole',
  INDIRECT__USER_ROLE: 'indirect_userRole',
};

export const HOURS = [
  '06:00',
  '06:30',
  '07:00',
  '07:30',
  '08:00',
  '08:30',
  '09:00',
  '09:30',
  '10:00',
  '10:30',
  '11:00',
  '11:30',
  '12:00',
  '12:30',
  '13:00',
  '13:30',
  '14:00',
  '14:30',
  '15:00',
  '15:30',
  '16:00',
  '16:30',
  '17:00',
  '17:30',
  '18:00',
  '18:30',
  '19:00',
  '19:30',
];

export const EVENT_TYPES = {
  agi: 1,
  allocationEquityAssembly: 2,
  allocationEquityVisit: 3,
  keyDelivery: 4,
  inspection: 5,
  individualSchedule: 6,
  generic: 7,
  technicalAssistance: 8,
};
export const EVENT_TYPES_BY_ID = {
  1: 'agi',
  2: 'allocationEquityAssembly',
  3: 'allocationEquityVisit',
  4: 'keyDelivery',
  5: 'inspection',
  6: 'individualSchedule',
  7: 'generic',
  8: 'technicalAssistance',
};

export const PARCEL_TYPES = {
  signal: 'Sinal',
  extra: 'Extra',
  financing: 'Financiamento',
  associative: 'Associativo',
  proSoluto: 'Pró-Soluto',
  proSolutoPos: 'Pró Soluto Pós',
  residue: 'Resíduo',
};

export const SOLICITATIONS_PAGE_STEPS = {
  INITIAL: '1',
  WAITING: '2',
  READY: '3',
};



// WEBPACK FOOTER //
// ./src/utils/constants.js